import React, { Suspense, startTransition } from 'react';
import './App.css';
import './fonts.css'; // Ensure fonts.css is imported
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from "./components/navbarlink";
import About from './pages/about';
import Contactus from './pages/contactus';
import { Globe } from './components/globeRotate';
import { SwipeCarousel } from './components/swipeCarousel.jsx';
import Counter from './components/counter';
import Footer from './components/footer';
import HoverText2 from "./components/aboutpagecomponents/bubble2";
import Horizontalanimatecard from "./components/aboutpagecomponents/horizontalCorousal";
import Publications from './pages/publications';

function App() {
  document.body.style = 'background: black;';

  return (
    <div className="App">
      <Router>
        <header>
          <Header />
        </header>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route
              path="/"
              element={
                <main>
                  <SwipeCarouselWrapper />
                  <Globe />
                  <CounterWrapper />
                  <div>
                    <HoverText2 />
                    <Horizontalanimatecard />
                  </div>
                </main>
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="/contactus" element={<Contactus />} />
            <Route path="/publications" element={<Publications />} />
          </Routes>
        </Suspense>
      </Router>

      <footer>
        <Footer />
      </footer>
    </div>
  );
}

function GlobeWrapper() {
  return (
    <Suspense fallback={<div>Loading Globe...</div>}>
      <Globe />
    </Suspense>
  );
}

function SwipeCarouselWrapper() {
  return (
    <Suspense fallback={<div>Loading Carousel...</div>}>
      <SwipeCarousel />
    </Suspense>
  );
}

function CounterWrapper() {
  return (
    <Suspense fallback={<div>Loading Counter...</div>}>
      <Counter />
    </Suspense>
  );
}

export default App;
